import React, { FunctionComponent, useEffect,useState } from "react";
import Navbar from "../Components/Navbar/Navbar";
import Analytics from "../Screens/Analytics/Analytics";
import Reports from "../Screens/Reports/Reports";
import { Route, Redirect, useLocation } from "react-router-dom";
import OrganizationPanel from "../Screens/OrganizationPanel/OrganizationPanel";
import AddUsers from "../Screens/AddUsers/AddUsers";
import { connect, useDispatch } from "react-redux";
import { fetchOrganizationsUsers, fetchOrganizationsUsersFromMongo } from "../Services/users";
import ApiPanel from "../Screens/ApiPanel/ApiPanel";
import NewsPanel from "../Screens/NewsPanel/NewsPanel";
import CustomButtonPanel from "../Screens/CustomButtonPanel/CustomButtonPanel";
import UpdatePassword from "../Screens/UpdatePassword/UpdatePassword";
import styles from '../Screens/Analytics/Analytics.module.css'
import AnalyticsSideNav from "../Components/AnalyticsSideNav/AnalyticsSideNav";
import organsationSettting from "../Screens/Settings/organsationSettting";
import helpModal from "../Components/Modals/help/helpModal";
import LeadManagerAnalytics from "../Screens/Analytics/LeadManagerAnalytics";


import UserPanel from "../Screens/UserPanel/UserPanel";
import Response from "../Screens/Response/Response";
import PropWiseResponse from "../Screens/Response/ResponsesPropertyWise";
import AddContacts from "../Screens/AddContacts/AddContacts";
import Task from "../Screens/TasksPanel/TaskPanel";
import Project from "../Screens/ProjectsPanel/ProjectsPanel";
import AddProject from "../Screens/AddProject/AddProject";
import AddTasks from "../Screens/AddTasks/AddTasks";
import Resources from "../Screens/Resources/Resources";
import ContactDetails from "../Screens/ContactDetails/ContactDetails";
import EditContact from "../Screens/EditContact/EditContact";

import CallLogsPanel from "../Screens/CallLogsPanel/CallLogsPanel";
import ProjectDetails from "../Screens/ProjectDetails/ProjectDetails";
import ProjectEditModal from "../Components/Modals/ProjectEditModal/ProjectEditModal";
import AddFAQ from "../Screens/AddFAQ/AddFAQ";
import FAQPanel from "../Screens/FAQPanel/FAQPanel";
import ApiDataPanel from "../Screens/ApiDataPanel/ApiDataPanel";
import LeadDistributor from "../Screens/LeadDistributor/LeadDistributor";
import "axios";
import axios from "axios";
import { setFreeTrialPackage } from "../Redux/actions";
import EditFAQ from "../Screens/EditFAQ/EditFAQ";
import MiniDrawer from "../Components/AnalyticsSideNav/SideNavBar";
import Booking from "../Screens/Booking/Booking";
import AddBooking from "../Screens/Booking/AddBooking";
import SubscriptionDetails from "../Screens/SubscriptionDetails/SubscriptionDetails";
import TransactionHistory from "../Screens/TransactionHistory/TransactionHistory";
import PaymentDetails from "../Screens/PaymentDetails/PaymentDetails";
import UpgradeUser from "../Screens/UpgradeUser/UpgradeUser";
import SubscriptionAlert from "../Components/SubscriptionAlert/SubscriptionAlert";
import AppUpdateAlert from "../Components/AppUpdateAlert/AppUpdateAlert";
import { boolean } from "yup";
import ReEnquiredApiDataPanel from "../Screens/ReEnquiredApiDataPanel/ReEnquiredApiDataPanel";
import InvoicePdf from "../Screens/PdfView/InvoicePdf";
import Settings from "../Screens/Settings/Settings";
import AuditLogs from "../Screens/AuditLogs/AuditLogs";
import Delete from "../Screens/DeleteLog/Delete";
import ReenquiredLeads from "../Screens/ReEnquiredLeads/ReenquiredLeads";
// import help from "../Screens/help/help";
import Integrations from "../Screens/Integrations/Integrations";
import Marketing from "../Screens/MarketingAutomation/Marketing";
import WelcomeMessagingModel from "../Components/Modals/WelcomeMessagingModel/WelcomeMessagingModel";
import WhatsappRechargePlans from "../Screens/WhatsappRechargePlans/WhatsappRechargePlans";
import RechargeTransactionHistory from "../Screens/RechargeTransactionHistory/RechargeTransactionHistory";
import EmailRechargePlans from "../Screens/EmailRechargePlans/EmailRechargePlans";
import moment from "moment";
import {fetchSingleMBData} from "../Services/contacts"
import Templates from "../Screens/MarketingAutomation/Templates";
import SetupWhatsappTemplates from "../Screens/MarketingAutomation/SetupWhatsappTemplates";
// import { updateShowWhatsappPurchaseModal } from "../Services/organizations";
import HelpSupport from "../Screens/HelpAndSupport/HelpAndSupport";
import LeadQualityScreen from "../Screens/LeadQuality/LeadQualityScreen";
import { deviceCheck } from "../Values/utils";
import { readproPackagePurchaseViaPGI } from "../Services/pgi";
import WhatsappRechargePlansNew from "../Screens/WhatsappRechargePlans/WhatsappRechargePlansNew";
import BannerManagement from "../bannerManagement/bannerDashBoard"
import bannerForm from "../bannerManagement/bannerForm"
import WhatsappTemplates from "../Screens/MarketingAutomation/WhatsappTemplates";
import CreateWhatsappTemplate from "../Screens/MarketingAutomation/CreateWhatsappTemplate";
import appBannerForm from "../bannerManagement/appBannerForm";

type props = {
  organizationId: string;
  history: any;
  authToken: string;
  initialParams: any;
  user: any;
  constants: any;
};

const OrganizationRoute: FunctionComponent<props> = ({
  organizationId,
  history,
  authToken,
  initialParams,
  user,
  constants
}) => {
  const [messagingPackModel, setMessagingPackModel] = useState(false);
  const [showSetupDispositionTemplates, setShowSetupDispositionTemplates] = useState(false);
  const [rootRedirectPath, setRootRedirectPath] = useState("/userManagement");
  const dispatcher = useDispatch();

  // useEffect(() => {
  //   const fetchData = async () => {
  //     const contact_id = localStorage.getItem("contact_id");

  //     // console.log("VFCD","I rannnn1 1111")
      
  //     if (contact_id) {
  //       try {
  //         // Assuming fetchSingleMBData is an async function that fetches data
  //         const data = await fetchSingleMBData(contact_id);
  //         // console.log("contact_details data",data)
  //         // Navigate to /contactDetails and pass contact_id in state
  //         localStorage.removeItem("contact_id")
  //         const formatDate = (date:any) => {
  //           return date ? moment(date).format('DD MMM YY, LT') : '';
  //         };
  //         history.push({
  //           pathname: "/contactDetails",
  //           state: { detail:{  ...data,
  //             created_at: formatDate(data['created_at']),
  //             lead_assign_time: formatDate(data['lead_assign_time']),
  //             next_follow_up_date_time: formatDate(data['next_follow_up_date_time']),
  //             modified_at: formatDate(data['modified_at']),
  //             stage_change_at: formatDate(data['stage_change_at']),
  //             feedback_time: formatDate(data['feedback_time']),
  //             due_date: formatDate(data['due_date']),
  //           } } // You can also pass the fetched data if needed
  //         });
  //       } catch (error) {
  //         console.error("Error fetching contact data", error);
  //       }
  //     }
  //   };

  //   fetchData(); // Call the async function
  // }, [history]);


  // Handle the case where in the URL redirect parameter is present
  useEffect(() => {
    if (initialParams["redirect"]) {
      setRootRedirectPath(`/${initialParams["redirect"]}`);
      history.push(`/${initialParams["redirect"]}`);
    }
    if (initialParams["packageId"] && user.user_super_oid && constants.freeTrialPackages) {
      // let tempFreeTrialPackages = constants.freeTrialPackages ? constants.freeTrialPackages : [];
      // let freeTrial = tempFreeTrialPackages.includes(initialParams["packageId"]);
      // if (freeTrial && !deviceCheck()) {
      //   dispatcher(setFreeTrialPackage(true));
      // }
      // else {
        readproPackagePurchaseViaPGI(user.user_super_oid, initialParams["packageId"], dispatcher, deviceCheck(), "", "", initialParams);
      // }
    }
  }, [initialParams, user.user_super_oid, constants])

  useEffect(() => {
    
    if (organizationId) {
      // const unSub = fetchOrganizationsUsers(
      //   dispatcher,
      //   organizationId
      // );
      // return unSub;
      fetchOrganizationsUsersFromMongo(
        dispatcher,
        organizationId,
      );
    }
    // if (organizationData.show_whatsapp_purchase_modal) {
    //   setMessagingPackModel(true);
    // }
    // eslint-disable-next-line
  }, [authToken,organizationId]);


  const location = useLocation();
  let helpPage = location.pathname.includes('/help')?true:false;
  let leadqualityPage = location.pathname.includes('/leadquality')?true:false;

  return (
    <>
      {/* {messagingPackModel === true && (
        <WelcomeMessagingModel
          open={messagingPackModel}
          close={()=>{
            setMessagingPackModel(false);
            updateShowWhatsappPurchaseModal(organizationId,false);
          }}
          showSetupScreen={()=>{
            setMessagingPackModel(false);
            // history.push("marketing");
            history.push({
              pathname: '/marketing',
              state: {
                showSetupScreen:true
              },
            });
            dispatcher(setLockSideNavbar({ lockSideNavbar: true }));
          }}
        />
      )} */}
      {((!helpPage || !leadqualityPage )&& !deviceCheck()) && <Navbar
        props={{ history }}
        title={"Users"}
        path={"/"}
        leadManger={false}
        api={"/apis"}
        news={"/news"}
        // customButton={"/customButton"}
      />}
      <div className={styles.parent}>
        <AnalyticsSideNav
          props={{ history }}
          title={"Users"}
          path={"/"}
          leadManger={false}
          operationManger={false}
          api={"/apis"}
          news={"/news"}
          customButton={"/customButton"}
          updatePassword={"/updateUserPassword"}
          organsationSettting={"organsationSettting"}
          bannerManagement={"/banerManagement"}
          // help={"/help"}
          // mmb={"/mmb"} 
        />
        {/* <Route exact path="/" component={OrganizationPanel} /> */}
        <Route exact path="/">
          <Redirect to={rootRedirectPath} />
        </Route>
        <Route exact path="/userManagement" component={OrganizationPanel} />
        <Route exact path="/contacts" component={UserPanel} />
        <Route exact path="/response" component={Response} />
        <Route exact path="/propwiseresponse" component={PropWiseResponse} />
        <Route path="/analytics" component={LeadManagerAnalytics} />
        {/* <Route path="/analytics" component={Analytics} /> */}
        <Route path="/reports" component={Reports} />
        <Route path="/apis" component={ApiPanel} />
        <Route path="/addUsers" component={AddUsers} />
        <Route path="/news" component={NewsPanel} />
        <Route path="/updateUserPassword" component={UpdatePassword} />
        {/* <Route
          path="/customButton"
          component={CustomButtonPanel}
        /> */}
        <Route path="/organsationSettting" component={organsationSettting} />
        {/* <Route path="/help" component={helpModal} /> */}
        {/* <Route exact path="/" component={UserPanel} /> */}
        <Route path="/reports" component={Reports} />
        <Route path="/addProjects" component={AddProject} />
        <Route path="/addTasks" component={AddTasks} />
        <Route path="/contactDetails" component={ContactDetails} />
        <Route path="/tasks" component={Task} />
        <Route path="/projects" component={Project} />
        <Route path="/resources" component={Resources} />
        <Route path="/addContacts" component={AddContacts} />
        <Route path="/editContacts" component={EditContact} />
        <Route path="/callLogs" component={CallLogsPanel} />
        <Route path="/projectDetails" component={ProjectDetails} />
        <Route path="/editProjects" component={ProjectEditModal} />
        <Route path="/addFAQ" component={AddFAQ} />
        <Route path="/editFAQ" component={EditFAQ} />
        <Route path="/faqs" component={FAQPanel} />
        <Route path="/leadDistributor" component={LeadDistributor} />
        <Route path="/apiData" component={ApiDataPanel} />
        <Route path="/integrations" component={Integrations} />
        <Route path="/booking" component={Booking} />
        <Route path="/addBooking" component={AddBooking} />
        <Route path="/viewBookingDetails" component={AddBooking} />
        <Route path="/subscriptionDetails" component={SubscriptionDetails} />
        <Route path="/leadquality" component={LeadQualityScreen} />
        <Route path="/whatsappRechargePlans" component={WhatsappRechargePlansNew} />
        <Route path="/emailRechargePlans" component={EmailRechargePlans} />
        <Route path="/rechargeTransactionHistory" component={RechargeTransactionHistory} />
        <Route path="/settings" component={Settings} />
        <Route path="/auditLogs" component={AuditLogs} />
        <Route path="/marketing" component={Marketing}/>
        <Route path="/templates" component={Templates}/>
        <Route path="/whatsapptemplates" component={WhatsappTemplates}/>
        <Route path="/createwhatsapptemplate" component={CreateWhatsappTemplate}/>
        <Route path="/banerManagement" component={BannerManagement}/>
        <Route path="/help" component={HelpSupport}/>
        <Route path="/AddBanner" component={bannerForm}/>
        <Route path="/AddAppBanner" component={appBannerForm}/>
      </div>
    </>
  );
};

const mapStateToProps = (state: any) => {
  return {
    organizationId: state.organization.id,
    authToken:state.user.authToken,
    initialParams:state.utils.initialParams,
    user: state.user.data,
    constants: state.constants.data,
  };
};

export default connect(mapStateToProps)(OrganizationRoute);